import { WordLength } from '../types/game'
import dictionary from '../constants/dictionary.json'

// Add type assertion to ensure TypeScript recognizes dictionary as string array
const wordList = dictionary as string[]

export class ValidationError extends Error {
  constructor(
    message: string,
    public readonly code:
      | 'INVALID_LENGTH'
      | 'NOT_IN_DICTIONARY'
      | 'INVALID_CHARS'
  ) {
    super(message)
    this.name = 'ValidationError'
  }
}

export interface WordValidationResult {
  isValid: boolean
  error?: ValidationError
}

export class WordValidationService {
  private static instance: WordValidationService
  private dictionarySet: Set<string>

  private constructor() {
    this.dictionarySet = new Set(
      wordList.map((word: string) => word.toLowerCase())
    )
  }

  public static getInstance(): WordValidationService {
    if (!WordValidationService.instance) {
      WordValidationService.instance = new WordValidationService()
    }
    return WordValidationService.instance
  }

  public validateWord(
    word: string,
    expectedLength: WordLength
  ): WordValidationResult {
    try {
      this.validateLength(word, expectedLength)
      this.validateCharacters(word)
      // TODO: Uncomment this when we have a ChiShona dictionary alright
      // this.validateInDictionary(word)

      return { isValid: true }
    } catch (error) {
      if (error instanceof ValidationError) {
        return { isValid: false, error }
      }
      throw error
    }
  }

  private validateLength(word: string, expectedLength: WordLength): void {
    if (word.length !== expectedLength) {
      throw new ValidationError(
        `Word must be ${expectedLength} letters long`,
        'INVALID_LENGTH'
      )
    }
  }

  private validateCharacters(word: string): void {
    // Allow letters and apostrophes for the Shona language
    if (!/^[a-zA-Z']+$/.test(word)) {
      throw new ValidationError(
        'Word must contain only letters and apostrophes',
        'INVALID_CHARS'
      )
    }
  }

  // private validateInDictionary(word: string): void {
  //   if (!this.dictionarySet.has(word.toLowerCase())) {
  //     throw new ValidationError(
  //       'Word not found in dictionary',
  //       'NOT_IN_DICTIONARY'
  //     )
  //   }
  // }

  // For testing purposes
  public clearDictionary(): void {
    if (process.env.NODE_ENV === 'test') {
      this.dictionarySet.clear()
    }
  }

  public addCustomWords(words: string[]): void {
    words.forEach((word) => this.dictionarySet.add(word.toLowerCase()))
  }
}

// Add more validation features
// Add performance optimizations
